<div class="ui-dropdown"
	[ngClass]="{ 'knock-out-wrap': disabled }">
	<button #toggleBtn
		class="ui-dropdown-btn"
		[ngClass]="{
			'knock-out-btn': disabled,
			'apply-btn-hover': !disabled && applyHoverClass,
			'apply-btn-focus': !disabled && applyFocusClass,
			'apply-btn-list-open': isDropDownOpen
		}"
		type="button"
		id="{{ dropDownId }}"
		[attr.aria-label]="dropDownName + ' '+ narratorLabel"
		role="combobox"
		aria-haspopup="true"
		[attr.aria-expanded]="isDropDownOpen"
		[disabled]="disabled"
		(click)="isDropDownOpen = !isDropDownOpen; applyFocusClass = !applyFocusClass"
		(mouseover)="applyHoverClass = !applyFocusClass ? true : false"
		(mouseleave)="applyHoverClass = false"
		(focus)="applyFocusClass = true"
		(blur)="applyFocusClass = false"
		tabindex="0">
		<div
			(click)="toggleList($event)"
			aria-hidden="true"
			class="ui-dropdown-btn-m-label">
			<span class="ui-dropdown-btn-m-label-name">{{ name }}</span>
			<span class="ui-dropdown-btn-m-label-s">{{ placeholder }}</span>
		</div>
		<span>
			<fa-icon class="chevron"
				[ngClass]="{
					'knock-out-chevron': disabled,
					'apply-chevron-up': isDropDownOpen
				}"
				[attr.aria-label]="isDropDownOpen? 'Arrow Up': 'Arrow Down'"
				(click)="toggleList($event)"
				[icon]="isDropDownOpen ? iconUp : iconDown">
			</fa-icon>
		</span>
	</button>
	<div uiDropdownNavigate
		id="ui-dropDown-value"
		[isDropdownOpen]="isDropDownOpen"
		[selectedChild]="selectedValue"
		(closeDropdown)="closeDropdown($event)"
		class="ui-menu-dropdown"
		*ngIf="isDropDownOpen && !disabled"
		role="listbox"
		[tabindex]="isDropDownOpen ? 0 : -1"
		[attr.aria-labelledby]="dropDownId"
	>
		<a *ngFor="let item of list; let i = index"
			role="option"
			[ngClass]="{ 'selected-list-item': selectedValue === i }"
			id="{{ item.text }}"
			(click)="closeDropdown({ value: i, hideList: false })"
			tabindex="-1"
			[attr.aria-selected]="selectedValue === i ? true : false">{{ item.text }}</a>
	</div>
</div>
